import React from "react";
//Material imports
import TableIconButton from "../table-icon-button/TableIconButton";
import RefreshIcon from "@mui/icons-material/History";
import { ThemeProvider } from "@mui/material/styles";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";
const TableRefreshIcon = props => {
  const theme = useCustomTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(TableIconButton, props, /*#__PURE__*/React.createElement(RefreshIcon, null)));
};
export default TableRefreshIcon;